import React, { useEffect, useRef, useCallback } from 'react';
import { useCodeMirror } from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
import { EditorView } from '@codemirror/view';
import { EditorState } from '@codemirror/state';

const JsonEditorViewer = ({ initialJson, setContext }) => {
  const editorRef = useRef();

  const handleChange = useCallback(
    (state) => {
      const currentValue = state.doc.toString();
      setContext(currentValue);
    },
    [setContext]
  );
  if (!initialJson) {
    initialJson = '{}';
  }
  const { setContainer } = useCodeMirror({
    container: editorRef.current,
    value: initialJson,
    extensions: [
      json(),
      EditorView.lineWrapping,
      EditorState.changeFilter.of((change) => {
        handleChange(change.state);
        return true;
      })
    ]
  });

  useEffect(() => {
    setContainer(editorRef.current);
  }, [setContainer]);

  return <div ref={editorRef} className='max-h-unit-9xl overflow-auto' />;
};

export default JsonEditorViewer;
